'use client';

import { FeatureFlagProvider } from 'harness-react';
import { Box, ThemeProvider } from '@mui/material';
import theme from 'ui/theme';
import { replaceUrls } from 'utils/urls';
import { DefaultFooter, SideNavBar, StickyNavBar } from 'ui';
import BrazeProvider from './brazeProvider';

export default function ClientLayout({
  children,
  featureFlagApiKey,
  brazeConfig,
  ctaLink,
  menuData,
  environment,
  footerData,
}) {
  const ctaLinkUrl = ctaLink.shopLink ? replaceUrls(ctaLink.shopLink, environment) : '';

  return (
    <FeatureFlagProvider apiKey={featureFlagApiKey}>
      <BrazeProvider brazeConfig={brazeConfig}>
        <ThemeProvider theme={theme}>
          <Box
            data-testid='mainLayout'
            backgroundColor='colorTheme.backgroundPrimaryLightWeb'
            display='flex'
            flexDirection='column'
            position='relative'
            zIndex='1'
          >
            <StickyNavBar
              menuData={menuData}
              cta={{ url: ctaLinkUrl, text: menuData?.buttonText }}
              environment={environment}
            />
            <SideNavBar
              menuData={menuData}
              cta={{ url: ctaLinkUrl, text: menuData?.buttonText }}
              environment={environment}
            />
            <Box
              position='relative'
              overflow='visible'
              zIndex='1'
              display='grid'
              gridTemplateColumns='repeat(14, 1fr)'
              gap={{
                xs: '0 8px',
                md: '0 24px',
                lg: '0 48px',
              }}
            >
              {children}
            </Box>
            <Box mt={8}>
              <DefaultFooter environment={environment} data={footerData} />
            </Box>
          </Box>
        </ThemeProvider>
      </BrazeProvider>
    </FeatureFlagProvider>
  );
}
